<sync-dialog 
    [config]="dialogConfig" 
    [open]="openState === 99" 
    [isFullScreen]="false">
    <app-error
        *ngIf="errcode"
        [errcode]="errcode"
    ></app-error>
</sync-dialog>  